import { GameVars } from "../GameVars";


export class ScoreContainer extends Phaser.GameObjects.Container {

    private static readonly NUMBER_MS = 5;
    private score: Phaser.GameObjects.Image[];
    private spacing: number;
    private lastX: number;
    private scoreNum: number;
    private scoreTotal: number;
    private tween: Phaser.Tweens.Tween;
    private textureAtlas: string;

    constructor(scene: Phaser.Scene, textureAtlas: string, spacing: number = 0) {
        super(scene);

        this.textureAtlas = textureAtlas;
        this.score = [];
        this.spacing = spacing;
        this.lastX = this.x;
        this.scoreNum = 0;
        this.scoreTotal = 0;
        this.tween = null;
    }

    public getScore(): number {
        return this.scoreTotal;
    }

    public updateScore(score: number) {

        if (this.tween) {
            this.tween.remove();
        }

        let diff = score - this.scoreTotal;
        this.scoreTotal = score;

        var that = this;
        this.tween = this.scene.tweens.add({
            targets: this,
            scoreNum: score,
            duration: diff * ScoreContainer.NUMBER_MS,
            ease: Phaser.Math.Easing.Linear,
            onUpdate: function() {
                that.changeScoreNumbers(GameVars.formatNumber(Math.floor(that.scoreNum)).toString());
            },
            onComplete: function() {
                that.tween = null;
            }
        });
    }   

    private changeScoreNumbers(score: string): void {

        this.destroyScore();
       
        this.x = this.lastX;

        let currentX = this.x;
        let currentY = this.y;

        for (let i = 0; i < score.length; ++i) {
            const letter = new Phaser.GameObjects.Image(this.scene, currentX, currentY, this.textureAtlas, score[i]);
            letter.setOrigin(0, score[i] === "," ? 0.5 : 0.5);
            currentX += letter.frame.width + this.spacing;

            this.score.push(letter);
            this.add(letter);
        }

        this.x -= (currentX - this.lastX) * 0.5;
    }

    private destroyScore(): void {

        if (this.score.length > 0) {
            for (let i = 0; i < this.score.length; ++i) {
                this.score[i].destroy();
            }
            this.score = [];
        }
    }
};